import { GermanLangKey, useTranslation } from '../../useTranslation'
import { useQueryWithLoader } from '../loader/useQueryWithLoader'
import { useInfoApi } from '../../common/api-context'
import NewsletterForm from '../newsletter/newsletterform'
import { useContext, useState } from 'react'
import { GlobalContext } from '../../common/global-context'
import useConfirm from '../../common/hooks/useConfirm'
import useVersionCheck from '../../common/hooks/useVersionCheck'
interface FooterProps {
    responsive?: boolean
}

const Footer: React.FC<FooterProps> = ({ responsive = false }) => {
    const { t, i18n } = useTranslation()
    const infoApi = useInfoApi()
    const { settings } = useContext(GlobalContext)
    const { activeVersion } = useVersionCheck()
    const { data: buildVersion } = useQueryWithLoader('getBuildVersion', ['getBuildVersion'], async () => (await infoApi.buildProperties()).data, {
        staleTime: 600000, //10 minutes
    })
    const [showResetConfiguration, setShowResetConfiguration] = useState<boolean>(() => !!localStorage.getItem('RING_PROFILE_CONFIG'))

    const [getResetConfigurationConfirmation, ResetConfigurationConfirmation] = useConfirm()

    const resetConfiguration = async () => {
        if (await getResetConfigurationConfirmation({ description: t('footer.areYouSureYouWantToResetConfiguration') })) {
            localStorage.removeItem('RING_PROFILE_CONFIG')
            setShowResetConfiguration(false)
        }
    }

    const navItems = [
        {
            label: t('footer.imprint'),
            url: i18n.language === GermanLangKey ? 'https://www.heimerle-meule.com/de/impressum' : 'https://www.heimerle-meule.com/imprint',
        },
        {
            label: t('footer.gtc'),
            url: i18n.language === GermanLangKey ? 'https://www.heimerle-meule.com/de/agbs' : 'https://www.heimerle-meule.com/gtc',
        },
        {
            label: t('footer.privacyPolicy'),
            url: i18n.language === GermanLangKey ? 'https://www.heimerle-meule.com/de/datenschutz' : 'https://www.heimerle-meule.com/data-protection',
        },
    ]

    return (
        <div className="footer bg-custom_gray">
            <ResetConfigurationConfirmation />
            <div
                className={`container flex gap-3 py-12 px-0 pb-6 text-white max-tablet:w-full max-tablet:max-w-full max-tablet:px-7 ${
                    responsive && 'max-md:flex-wrap max-md:text-center'
                }`}
            >
                <div className={`widget-col-1 w-3/12 max-tablet:w-1/3 ${responsive && 'max-md:w-full max-md:justify-center'}`}>
                    <h4 className="pb-4 font-bold leading-5 text-[15px] max-tablet:text-sm">Heimerle+Meule GmbH</h4>
                    <p className="text-[13px] leading-5">
                        {t('footer.goldAndSilverRefinery')}
                        <br />
                        <br />
                        Dennigstraße 16
                        <br />
                        75179 Pforzheim
                        <br />
                        Deutschland
                        <br />
                        +49 7231 940 - 0<br />
                        info@heimerle-meule.com
                        <br />
                        Mo. - Fr.: 08:00 - 16:00 {t('hours')}
                    </p>
                </div>
                <div className={`widget-col-2 w-3/12 max-tablet:w-1/3 ${responsive && 'max-md:w-full max-md:justify-center'}`}>
                    <h4 className="pb-4 font-bold leading-5 text-[15px] max-tablet:text-sm">{t('footer.informations')}</h4>
                    <p className="text-[13px] leading-5">
                        <a
                            href={
                                i18n.language === GermanLangKey
                                    ? 'https://www.heimerle-meule.com/de/unternehmen/ueber-uns'
                                    : 'https://www.heimerle-meule.com/company/about-us'
                            }
                            target="_blank"
                            data-cy="footer-about-link"
                        >
                            {t('homePage.aboutUs')}
                        </a>
                    </p>
                </div>

                <div className={`widget-col-3 newsletter-form-holder w-[27%] max-tablet:w-1/3  ${responsive && 'max-md:w-full max-md:justify-center'}`}>
                    {!settings.maintenanceMode && <NewsletterForm responsive />}
                </div>
            </div>

            <div
                className={`footer-nav-list container py-10 d-flex text-white uppercase gap-10 block text-sm max-tablet:w-full max-tablet:max-w-full max-tablet:px-7 ${
                    responsive && 'max-md:w-full max-md:justify-center max-md:text-center'
                }`}
            >
                {navItems.map((item, index) => (
                    <a className="mr-5" href={item.url} key={item.label} target="_blank" data-cy={`footer-nav-link-${index}`}>
                        {item.label}
                    </a>
                ))}
                {buildVersion && <div className="text-[13px] capitalize mt-6">{`Version: ${buildVersion.version} | ${activeVersion}`}</div>}
                <div className="text-[13px] capitalize mt-6 flex gap-4">
                    {showResetConfiguration && (
                        <>
                            <div onClick={resetConfiguration} className="cursor-pointer" data-cy="reset-configuration">
                                {t('footer.resetConfiguration')}
                            </div>
                            |
                        </>
                    )}

                    <a href="https://get.teamviewer.com/6tq98wg" target="_blank" className="cursor-pointer" data-cy="remote-support-link">
                        {t('footer.downloadRemoteSupportClient')}
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer
